export default __webpack_public_path__ + "static/image11-624e08491833809e1ce8ed8c372f98f2.gif";